module.exports = __webpack_public_path__ + "img/1.43adff28.jpg";